import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import FilterSidebar from './components/FilterSidebar';
import ProductGrid from './components/ProductGrid';
import SortDropdown from './components/SortDropdown';
import SearchBar from './components/SearchBar';
import CategoryTabs from './components/CategoryTabs';

const ProductCatalogBrowse = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filters, setFilters] = useState({});
  const [sortBy, setSortBy] = useState('featured');
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [loading, setLoading] = useState(false);

  // Mock product data
  const allProducts = [
    {
      id: 1,
      name: "K.L: Trainers. Z.G.",
      category: "shoes",
      brand: "nike",
      price: 150.00,
      originalPrice: 180.00,
      image1: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=400&fit=crop",
      image:"/assets/images/shoeskl.jpg",
      description: "Comfortable running shoes with excellent cushioning and modern design perfect for daily wear.",
      isNew: true,
      discount1: 17,
      rating: 4.5,
      reviews: 128,
      sizes1: ["7", "8", "9", "10", "11", "12"],
      colors: ["black", "white", "blue"]
    },
    {
      id: 2,
      name: "K.L: Trainers. Z.G.",
      category: "shoes",
      brand: "adidas",
      price: 180.00,
      image1: "https://images.unsplash.com/photo-1608231387042-66d1773070a5?w=400&h=400&fit=crop",
      image: "/assets/images/shoesklbalck.jpg",
      description: "Premium running shoes with responsive cushioning and energy return technology.",
      rating: 4.7,
      reviews: 95,
      sizes: ["7", "8", "9", "10", "11"],
      colors: ["black", "white"]
    },
    {
      id: 3,
      name: "Classic Denim Jacket",
      category: "clothes",
      brand: "levi",
      price: 89.99,
      originalPrice: 120.00,
     image: "/assets/images/jacket.jpg",
      description: "Timeless denim jacket made from premium cotton with classic fit and vintage wash.",
      discount: 25,
      rating: 4.3,
      reviews: 67,
      sizes: ["S", "M", "L", "XL"],
      colors: ["blue", "black"]
    },
    {
      id: 4,
      name: "Leather Crossbody Bag",
      category: "bags",
      brand: "coach",
      price: 245.00,
      image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=400&fit=crop",
      description: "Elegant leather crossbody bag with adjustable strap and multiple compartments.",
      isNew: true,
      rating: 4.8,
      reviews: 43,
      colors: ["brown", "black"]
    },
    {
      id: 5,
      name: "Puma RS-X Sneakers",
      category: "shoes",
      brand: "puma",
      price: 110.00,
      image: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=400&h=400&fit=crop",
      description: "Retro-inspired sneakers with bold design and comfortable cushioning system.",
      rating: 4.2,
      reviews: 156,
      sizes: ["7", "8", "9", "10", "11", "12"],
      colors: ["white", "black", "red"]
    },
    {
      id: 6,
      name: "Cotton Blend T-Shirt",
      category: "clothes",
      brand: "uniqlo",
      price: 19.99,
      image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=400&fit=crop",
      description: "Soft cotton blend t-shirt with comfortable fit and breathable fabric.",
      rating: 4.1,
      reviews: 234,
      sizes: ["XS", "S", "M", "L", "XL", "XXL"],
      colors: ["white", "black", "blue", "red"]
    },
    {
      id: 7,
      name: "Canvas Tote Bag",
      category: "bags",
      brand: "everlane",
      price: 45.00,
      image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=400&fit=crop",
      description: "Durable canvas tote bag perfect for everyday use with spacious interior.",
      rating: 4.4,
      reviews: 89,
      colors: ["white", "black", "brown"]
    },
    {
      id: 8,
      name: "Converse Chuck Taylor",
      category: "shoes",
      brand: "converse",
      price: 65.00,
      image: "https://images.unsplash.com/photo-1607522370275-f14206abe5d3?w=400&h=400&fit=crop",
      description: "Classic high-top sneakers with timeless design and comfortable canvas upper.",
      rating: 4.6,
      reviews: 312,
      sizes: ["6", "7", "8", "9", "10", "11", "12"],
      colors: ["white", "black", "red"]
    },
    {
      id: 9,
      name: "Wool Blend Sweater",
      category: "clothes",
      brand: "zara",
      price: 79.99,
      originalPrice: 99.99,
      image: "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?w=400&h=400&fit=crop",
      description: "Cozy wool blend sweater with ribbed cuffs and hem, perfect for cooler weather.",
      discount: 20,
      rating: 4.3,
      reviews: 78,
      sizes: ["S", "M", "L", "XL"],
      colors: ["brown", "black", "white"]
    },
    {
      id: 10,
      name: "Backpack Travel Bag",
      category: "bags",
      brand: "herschel",
      price: 89.99,
      image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=400&fit=crop",
      description: "Spacious travel backpack with laptop compartment and water-resistant material.",
      isNew: true,
      rating: 4.7,
      reviews: 156,
      colors: ["black", "blue", "green"]
    },
    {
      id: 11,
      name: "Reebok Classic Leather",
      category: "shoes",
      brand: "reebok",
      price: 75.00,
      image: "https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400&h=400&fit=crop",
      description: "Iconic leather sneakers with vintage appeal and comfortable fit.",
      rating: 4.4,
      reviews: 203,
      sizes: ["7", "8", "9", "10", "11"],
      colors: ["white", "black"]
    },
    {
      id: 12,
      name: "Casual Button Shirt",
      category: "clothes",
      brand: "jcrew",
      price: 69.99,
      image: "https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=400&h=400&fit=crop",
      description: "Versatile button-up shirt made from premium cotton with modern fit.",
      rating: 4.2,
      reviews: 91,
      sizes: ["S", "M", "L", "XL", "XXL"],
      colors: ["white", "blue", "black"]
    }
  ];

  // Filter and sort products
  const filteredAndSortedProducts = useMemo(() => {
    let filtered = [...allProducts];

    // Filter by category
    if (activeCategory !== 'all') {
      filtered = filtered?.filter(product => product?.category === activeCategory);
    }

    // Filter by search query
    if (searchQuery) {
      filtered = filtered?.filter(product =>
        product?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
        product?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
        product?.category?.toLowerCase()?.includes(searchQuery?.toLowerCase())
      );
    }

    // Apply filters
    if (filters?.categories && filters?.categories?.length > 0) {
      filtered = filtered?.filter(product => filters?.categories?.includes(product?.category));
    }

    if (filters?.brands && filters?.brands?.length > 0) {
      filtered = filtered?.filter(product => filters?.brands?.includes(product?.brand));
    }

    if (filters?.sizes && filters?.sizes?.length > 0) {
      filtered = filtered?.filter(product => 
        product?.sizes && product?.sizes?.some(size => filters?.sizes?.includes(size?.toLowerCase()))
      );
    }

    if (filters?.colors && filters?.colors?.length > 0) {
      filtered = filtered?.filter(product => 
        product?.colors && product?.colors?.some(color => filters?.colors?.includes(color))
      );
    }

    if (filters?.rating) {
      filtered = filtered?.filter(product => product?.rating >= filters?.rating);
    }

    // Sort products
    switch (sortBy) {
      case 'newest':
        filtered?.sort((a, b) => (b?.isNew ? 1 : 0) - (a?.isNew ? 1 : 0));
        break;
      case 'price-low':
        filtered?.sort((a, b) => a?.price - b?.price);
        break;
      case 'price-high':
        filtered?.sort((a, b) => b?.price - a?.price);
        break;
      case 'rating':
        filtered?.sort((a, b) => (b?.rating || 0) - (a?.rating || 0));
        break;
      case 'popularity':
        filtered?.sort((a, b) => (b?.reviews || 0) - (a?.reviews || 0));
        break;
      case 'name-az':
        filtered?.sort((a, b) => a?.name?.localeCompare(b?.name));
        break;
      case 'name-za':
        filtered?.sort((a, b) => b?.name?.localeCompare(a?.name));
        break;
      default:
        // Featured - keep original order
        break;
    }

    return filtered;
  }, [allProducts, activeCategory, searchQuery, filters, sortBy]);

  const handleSearchSubmit = (query) => {
    setSearchQuery(query);
  };

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const activeFiltersCount = Object.values(filters)?.reduce((count, filterValue) => {
    if (Array.isArray(filterValue)) {
      return count + filterValue?.length;
    }
    return filterValue ? count + 1 : count;
  }, 0);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="pt-16">
        <div className="flex">
          {/* Filter Sidebar */}
          <FilterSidebar
            isOpen={isFilterOpen}
            onClose={() => setIsFilterOpen(false)}
            filters={filters}
            onFilterChange={handleFilterChange}
          />

          {/* Main Content */}
          <div className="flex-1 min-h-screen">
            <div className="p-6 lg:p-8">
              {/* Page Header */}
              <div className="mb-8">
                <h1 className="text-3xl font-bold text-foreground mb-2">
                  Product Catalog
                </h1>
                <p className="text-muted-foreground">
                  Discover our latest collection of shoes, clothes, and bags
                </p>
              </div>

              {/* Category Tabs */}
              <CategoryTabs
                activeCategory={activeCategory}
                onCategoryChange={setActiveCategory}
              />

              {/* Search and Filter Bar */}
              <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mb-6">
                <div className="flex items-center gap-4 flex-1">
                  <Button
                    variant="outline"
                    onClick={toggleFilter}
                    iconName="Filter"
                    iconPosition="left"
                    className="lg:hidden"
                  >
                    Filters
                    {activeFiltersCount > 0 && (
                      <span className="ml-2 bg-accent text-accent-foreground px-2 py-0.5 rounded-full text-xs">
                        {activeFiltersCount}
                      </span>
                    )}
                  </Button>

                  <SearchBar
                    searchQuery={searchQuery}
                    onSearchChange={setSearchQuery}
                    onSearchSubmit={handleSearchSubmit}
                  />
                </div>

                <div className="flex items-center gap-4">
                  <SortDropdown
                    sortBy={sortBy}
                    onSortChange={setSortBy}
                  />

                  <Button
                    variant="outline"
                    onClick={toggleFilter}
                    iconName="Filter"
                    iconPosition="left"
                    className="hidden lg:flex"
                  >
                    Filters
                    {activeFiltersCount > 0 && (
                      <span className="ml-2 bg-accent text-accent-foreground px-2 py-0.5 rounded-full text-xs">
                        {activeFiltersCount}
                      </span>
                    )}
                  </Button>
                </div>
              </div>

              {/* Results Summary */}
              <div className="flex items-center justify-between mb-6">
                <p className="text-sm text-muted-foreground">
                  Showing {filteredAndSortedProducts?.length} of {allProducts?.length} products
                  {searchQuery && (
                    <span> for "{searchQuery}"</span>
                  )}
                </p>

                {/* View Toggle */}
                <div className="flex items-center space-x-1 bg-muted rounded-lg p-1">
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8 bg-background shadow-sm"
                  >
                    <Icon name="Grid3X3" size={16} />
                  </Button>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8"
                  >
                    <Icon name="List" size={16} />
                  </Button>
                </div>
              </div>

              {/* Active Filters */}
              {activeFiltersCount > 0 && (
                <div className="flex flex-wrap items-center gap-2 mb-6">
                  <span className="text-sm text-muted-foreground">Active filters:</span>
                  
                  {filters?.categories && filters?.categories?.map(category => (
                    <span
                      key={category}
                      className="inline-flex items-center gap-1 px-3 py-1 bg-accent/10 text-accent rounded-full text-sm"
                    >
                      {category}
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-4 w-4 hover:bg-accent/20"
                        onClick={() => {
                          const updatedCategories = filters?.categories?.filter(c => c !== category);
                          handleFilterChange({ ...filters, categories: updatedCategories });
                        }}
                      >
                        <Icon name="X" size={12} />
                      </Button>
                    </span>
                  ))}

                  {filters?.brands && filters?.brands?.map(brand => (
                    <span
                      key={brand}
                      className="inline-flex items-center gap-1 px-3 py-1 bg-accent/10 text-accent rounded-full text-sm"
                    >
                      {brand}
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-4 w-4 hover:bg-accent/20"
                        onClick={() => {
                          const updatedBrands = filters?.brands?.filter(b => b !== brand);
                          handleFilterChange({ ...filters, brands: updatedBrands });
                        }}
                      >
                        <Icon name="X" size={12} />
                      </Button>
                    </span>
                  ))}

                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => handleFilterChange({})}
                    className="text-muted-foreground hover:text-foreground"
                  >
                    Clear all
                  </Button>
                </div>
              )}

              {/* Product Grid */}
              <ProductGrid
                products={filteredAndSortedProducts}
                loading={loading}
              />

              {/* Load More */}
              {filteredAndSortedProducts?.length > 0 && (
                <div className="flex justify-center mt-12">
                  <Button
                    variant="outline"
                    size="lg"
                    iconName="ChevronDown"
                    iconPosition="right"
                  >
                    Load More Products
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="bg-card border-t border-border mt-16">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center">
                  <Icon name="Footprints" size={20} color="var(--color-accent-foreground)" />
                </div>
                <span className="text-xl font-semibold text-primary">BRANDS OF LEGENDS</span>
              </div>
              <p className="text-sm text-muted-foreground">
                Your premier destination for fashion-forward shoes, clothes, and bags.
              </p>
            </div>
            
            <div>
              <h3 className="font-semibold text-foreground mb-3">Shop</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><Link to="/new-arrivals-showcase" className="hover:text-foreground">New Arrivals</Link></li>
                <li><a href="#" className="hover:text-foreground">Best Sellers</a></li>
                <li><a href="#" className="hover:text-foreground">Sale</a></li>
                <li><a href="#" className="hover:text-foreground">Gift Cards</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-semibold text-foreground mb-3">Support</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><a href="#" className="hover:text-foreground">Contact Us</a></li>
                <li><a href="#" className="hover:text-foreground">Size Guide</a></li>
                <li><a href="#" className="hover:text-foreground">Returns</a></li>
                <li><a href="#" className="hover:text-foreground">FAQ</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-semibold text-foreground mb-3">Connect</h3>
              <div className="flex space-x-3">
                <a href="https://wa.me/96170863807" target="_blank" rel="noopener noreferrer">
                <Button variant="ghost" size="icon">
                  <Icon name="Phone" size={20} />
                </Button>
                </a>
                <a href="https://www.facebook.com/brands.of.legends/" target="_blank" rel="noopener noreferrer">
                <Button variant="ghost" size="icon">
                  <Icon name="Facebook" size={20} />
                </Button>
                </a>
                <a href="https://twitter.com/brands_of_legend" target="_blank" rel="noopener noreferrer">
                  <Button variant="ghost" size="icon">
                    <Icon name="Twitter" size={20} />
                  </Button>
                </a>
                <a href="https://www.instagram.com/brands.of.legends/" target="_blank" rel="noopener noreferrer">
                  <Button variant="ghost" size="icon">
                    <Icon name="Instagram" size={20} />
                  </Button>
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-border mt-8 pt-8 text-center">
            <p className="text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} BRANDS OF LEGENDS. All rights reserved.
              <a target='_blank' href="https://apptomation.ca" className="hover:text-foreground"> | Apptomation</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProductCatalogBrowse;